"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * This component implements https://confluence.oci.oraclecorp.com/display/UX/Tabs
 */
var React = require("react");
var PropTypes = require("prop-types");
var classNames = require("classnames");
var index_1 = require("../../index");
var Aria_1 = require("../../resources/Aria");
/**
 * OUI tab component.
 *
 * @oui-component Tab
 */
var Tab = /** @class */ (function (_super) {
    __extends(Tab, _super);
    function Tab(props) {
        var _this = _super.call(this, props) || this;
        _this.onClickOverride = _this.onClickOverride.bind(_this);
        _this.performClick = _this.performClick.bind(_this);
        return _this;
    }
    Tab.prototype.render = function () {
        var _a = this.props, label = _a.label, disabled = _a.disabled, 
        // tslint:disable-next-line:no-unused
        children = _a.children, // will be extracted by Tabs.tsx and place in a different place
        // tslint:disable-next-line:no-unused
        isDefault = _a.isDefault, // for Tabs.tsx only to render the first tab
        // tslint:disable-next-line:no-unused
        onItemSelected = _a.onItemSelected, href = _a.href, LinkComponent = _a.linkComponent, linkComponentProps = _a.linkComponentProps, testId = _a.testId, rest = __rest(_a, ["label", "disabled", "children", "isDefault", "onItemSelected", "href", "linkComponent", "linkComponentProps", "testId"]);
        var isSelected = this.context.activeTabIndex === this.context.index;
        var styling = classNames({ "oui-active": isSelected }, { "oui-disabled": disabled });
        return this.context.isVerticalNav ? (React.createElement("li", { className: styling, id: this.context.linkId }, LinkComponent ? (React.createElement(LinkComponent, __assign({}, linkComponentProps, { "aria-selected": isSelected, onClick: this.onClickOverride }), label)) : (React.createElement(index_1.Link, __assign({}, rest, { "aria-selected": isSelected, linkType: href ? index_1.LinkType.Navigation : index_1.LinkType.Action, textStyle: href ? index_1.LinkTextStyle.None : index_1.LinkTextStyle.Default, href: href, onClick: !disabled && this.onClickOverride, title: label, testId: testId }), label)))) : (React.createElement("li", { className: styling },
            React.createElement(index_1.Button, { "aria-controls": this.context.panelId, "aria-label": label, "aria-selected": isSelected, disabled: disabled, id: this.context.linkId, onClick: this.onClickOverride, role: Aria_1.Roles.Tab, testId: testId, title: label }, label)));
    };
    Tab.prototype.performClick = function (event) {
        this.context.onSelect(this.context.index); // calling the onSelect in TabInternal.tsx
        if (this.props.onClick) {
            this.props.onClick(event);
        }
        // If we were passed a custom Link component, and an onClick handler was
        // provided in the component prop set, then also call that handler.
        if (this.props.linkComponent &&
            this.props.linkComponentProps &&
            this.props.linkComponentProps.onClick) {
            this.props.linkComponentProps.onClick(event);
        }
    };
    Tab.prototype.onClickOverride = function (event) {
        var _this = this;
        !this.props.href && event.preventDefault();
        if (this.props.onItemSelected) {
            var onTabSelectResult = this.props.onItemSelected();
            var onTabSelectResultType = typeof onTabSelectResult;
            if (onTabSelectResultType === "undefined" || onTabSelectResult === null) {
                // void return type
                this.performClick(event);
            }
            else if (onTabSelectResultType === "boolean" && onTabSelectResult) {
                // boolean return type
                this.performClick(event);
            }
            else if (onTabSelectResultType === "object" &&
                typeof onTabSelectResult.then === "function") {
                // promise return type
                var onTabSelectPromise = onTabSelectResult;
                onTabSelectPromise.then(function (ok) {
                    if (ok) {
                        _this.performClick(event);
                    }
                });
            }
        }
        else {
            this.performClick(event);
        }
    };
    Tab.contextTypes = {
        onSelect: PropTypes.func.isRequired,
        activeTabIndex: PropTypes.number,
        index: PropTypes.number,
        isVerticalNav: PropTypes.bool,
        linkId: PropTypes.string,
        panelId: PropTypes.string
    };
    return Tab;
}(React.Component));
exports.default = Tab;
//# sourceMappingURL=Tab.js.map